import { Props } from './module'
import { Blocks, Chips } from './ui'

interface PropsTabs extends Props {
  isNewVersion?: boolean
}

export const TabsPages = ({ isNewVersion = false, ...props }: PropsTabs) => {
  if (isNewVersion) return <Blocks {...props} />

  return <Chips {...props} />
}
